<template>
    <div class="company_tariff_devices" v-if="load">

        <div class="header">
            <div class="select">
                <label> {{ translate('company_services.tariff_name') }} </label>
                <sis-select
                    :options="tariff_list"
                    :multiple="false"
                    v-model="filter.tariff_id"
                    :placeholder="translate('company_services.tariff_name')"
                    :clearable="false"
                    :searchable="false"
                />
            </div>

            <div class="select">
                <label> {{ translate('company_services.client_name') }} </label>
                <sis-select
                    :options="client_list"
                    :multiple="false"
                    v-model="filter.client_id"
                    :placeholder="translate('company_services.client_name')"
                    :clearable="false"
                    :searchable="false"
                />
            </div>

            <div class="filter checkbox">
                <div class="info">
                    Trial
                </div>
                <label class="switch" @click.prevent="filter.trial = !filter.trial">
                    <input type="checkbox" v-model="filter.trial">
                    <span class="slider round"></span>
                </label>
            </div>

            <div class="button">
                <span
                    class="btn btn-warning text-center"
                    @click.prevent="clear_filter()"
                >
                    {{ translate('filter.reset') }}
                </span>

                <span
                    class="btn btn-success text-center"
                    @click.prevent="new_device_tariff()"
                >
                    {{ translate('company_services.add_device_tariff') }}
                </span>

            </div>
        </div>

        <div class="row response_table">
            <table>
                <thead style="height: 50px; flex:0; display: inline-block">
                    <tr>
                        <th scope="col" style="width: 40px" >
                            {{ translate('company_services.tariff_id') }}
                        </th>
                        <th scope="col" style="width: 40px" >
                            {{ translate('company_services.status') }}
                        </th>
                        <th scope="col">
                            {{ translate('company_services.device_fid') }}
                        </th>
                        <th scope="col">
                            {{ translate('company_services.device_name') }}
                        </th>
                        <th scope="col">
                            {{ translate('company_services.tariff_name') }}
                        </th>
                        <th scope="col">
                            {{ translate('company_services.username') }}
                        </th>
                        <th scope="col">
                            {{ translate('company_services.client_name') }}
                        </th>
                        <th scope="col">
                            {{ translate('company_services.ts_start') }}
                        </th>
                        <th scope="col">
                            {{ translate('company_services.ts_end') }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="(tariff_device,key) in tariff_devices"
                        :key="key"
                        class="tariff_item"
                    >
                        <td :data-label="translate('company_services.tariff_id')" style="width: 40px">
                            {{ tariff_device.id }}
                        </td>
                        <td :data-label="translate('company_services.status')" style="width: 40px" >
                            {{ tariff_device.status }}
                        </td>
                        <td :data-label="translate('company_services.device_fid')">
                            {{ tariff_device.fid }}
                        </td>
                        <td :data-label="translate('company_services.device_name')">
                            {{ tariff_device.device_name }}
                        </td>
                        <td :data-label="translate('company_services.device_name')">
                            {{ tariff_device.tariff_name }}
                        </td>
                        <td :data-label="translate('company_services.username')">
                            {{ tariff_device.username }}
                        </td>
                        <td :data-label="translate('company_services.client_name')">
                            {{ tariff_device.client_name }}
                        </td>
                        <td :data-label="translate('company_services.ts_start')">
                            {{ get_date(tariff_device.ts_start) }}
                        </td>
                        <td :data-label="translate('company_services.ts_end')">
                            {{ get_date(tariff_device.ts_end) }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="loading" v-else>
        <div class="spinner">
            <scale-loader />
        </div>
    </div>
</template>

<script>

import TextTable from 'components/UIComponents/Plugins/TextTablePlagin/TextTable.vue';
import AddDeviceTariff from "@/views/Dashboard/common/General/CompanyServices/Modal/AddDeviceTariff.vue";

export default {
    name: 'CompanyTariffDevices',
    components: {
        TextTable
    },
    props: ['tariffs', 'clients'],

    data () {
        return {
            tariff_devices: [],
            filter: {
                tariff_id: '',
                client_id: '',
                trial: false
            }
        }
    },

    computed:{
        load () {
            return this.tariffs.length > 0 && this.clients.length > 0
        },

        client_list(){
            let list = [{id: '', label: 'All clients'}]
            for (let client of this.clients) {
                list.push({ id: client.id, label: client.name })
            }
            return list
        },

        tariff_list(){
            let list = [{id: '', label: 'All tariffs'}]
            for (let tariff of this.tariffs) {
                list.push({ id: tariff.id, label: tariff.tariff_name })
            }
            return list
        },
        send_filter(){
            let filter = {}
            for (let filterKey in this.filter) {
                if (this.filter[filterKey] !== '' && this.filter[filterKey] !== null){
                    filter[filterKey] = this.filter[filterKey]
                }
            }
            console.log(filter)
            return filter
        }
    },

    watch:{
        'filter.tariff_id':{
            deep: false,
            handler(new_val){
                if (new_val !== undefined){
                    this.get_tariff_devices()
                }
            }
        },
        'filter.client_id':{
            deep: false,
            handler(new_val){
                if (new_val !== undefined){
                    this.get_tariff_devices()
                }
            }
        },
        'filter.trial':{
            deep: false,
            handler(){
                this.get_tariff_devices()
            }
        },

    },

    created () {
        this.get_tariff_devices()
    },

    methods: {
        get_tariff_devices(){
            this.$http.v1.getCompanyTariffDevices( this.send_filter ,(response) => {
                this.tariff_devices = response.data
            })
        },
        clear_filter(){
            this.filter =  {
                tariff_id: null,
                client_id: null,
                trial: false
            }
            this.get_tariff_devices(this.send_filter)
        },
        new_device_tariff () {
            let t = this.$createElement(AddDeviceTariff, {
                props: {
                    tariffs: this.tariffs
                },
                on: {
                    close: () => {
                        this.$modal.hide('add_device_tariff')
                    },
                    confirm: (val) => {
                        this.add_device_tariff(val)
                        this.$modal.hide('add_device_tariff')
                    }
                }
            })
            let temp = { render () { return t } }
            this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: true, scrollable: true, name: 'add_device_tariff'})
        },
        add_device_tariff(val){
            this.$http.v1.addDeviceTariff( val ,(response) => {
                this.global_notify('info', response.data.comment )
                this.get_tariff_devices()
            })
        }
    },
}
</script>
<style lang='scss' scoped>
  .company_tariff_devices{
    height: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
      .header{
          display: flex;
          align-content: center;
          justify-content: space-between;
          .select{
              width: 20%;
          }
          .checkbox{
              width: 20%;
          }
          .button{
              display: flex;
              align-content: center;
              justify-content: center;
              flex-direction: column;
              .btn{
                  padding: 0 5px;
                  margin-bottom: 5px;
                  &:last-child{
                      margin-bottom: 0;
                  }
              }
          }
      }
  }
 </style>
